import { ExEbDemandeTransporteur } from '../../../../classes/demandeTransporteur';
import { Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { EbDemande } from '../../../../classes/demande';
import { Component, OnInit, Injectable } from '@angular/core';
import { EbUser } from '../../../../classes/user';
import { DemandeStatus, Modules, ServiceType, CarrierStatus, TypeDemande, IDChatComponent, StatusDemande, ModeTransport, UserRole } from '../../../../utils/enumeration';
import { PricingService } from '../../../../services/pricing.service';
import { SearchCriteriaPricingBooking } from '../../../../utils/SearchCriteriaPricingBooking';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Statique } from '../../../../utils/statique';
import { Observable } from 'rxjs/Observable';
import { EbEtablissement } from '../../../../classes/etablissement';
import { RequestProcessing } from '../../../../utils/requestProcessing';
import { ModalService } from '../../../../shared/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { EbCompagnieCurrency } from '../../../../classes/compagnieCurrency';
import { EtablissementService } from '../../../../services/etablissement.service';
import { SearchCriteria } from '../../../../utils/searchCriteria';
import { EcCountry } from '../../../../classes/country';
import { CompleterItem } from 'ng2-completer';
import { EbParty } from '../../../../classes/party';
import { CompleterData, CompleterService } from 'ng2-completer';
import { ModeTrasnportQuotation } from '../../../../classes/ModeTrasportquotation';
import { CostCategorie, Cost } from '../../../../classes/costCategorie';
import { UserService } from '../../../../services/user.service';
import { EbChat } from '../../../../classes/chat';
import { ChatService } from '../../../../services/chat.service';
import { EbCompagnie } from '../../../../classes/compagnie';
import { StatiqueService } from '../../../../services/statique.service';
import { EcCurrency } from '../../../../classes/currency';


@Component({
	selector: 'app-cotation',
	templateUrl: './cotation.component.html',
	styleUrls: ['./cotation.component.css']
})
export class CotationComponent implements OnInit {

	IDChatComponent = IDChatComponent;
	Statique = Statique;
	UserRole = UserRole;

	@Output() updateChatEmitter = new EventEmitter<EbChat>();
	@Output() updateCarrierChoiceEmitter = new EventEmitter<void>();
	@Output() feedbackQuotationEmitter = new EventEmitter<ExEbDemandeTransporteur>();

	@Input() ebDemande: EbDemande;
	@Input() userConnected: EbUser;
	@Input() module: number;
	@Input() exEbDemandeTransporteur: ExEbDemandeTransporteur;
	@Input() hasContributionAccess?: boolean;
	@Input() isModal: boolean;
	@Input() isForEdit: boolean;

	formattedPickupTime: NgbDateStruct;
	formattedDeliveryTime: NgbDateStruct;
	listDemandeTransporteur: Array<ExEbDemandeTransporteur> = new Array<ExEbDemandeTransporteur>();

	ConstantsTranslate: Object;
	listCountry: Array<EcCountry>;
	suggetions: CompleterData;
	listPostCostCategorie: Array<CostCategorie>;
	modeTranspo: String = null;
	listAllCostCategorie: Array<CostCategorie>;
	listCurrency: Array<EcCurrency>;
	modeTransport: any = Statique.modeTransport;
	typeTransport: any = Statique.TypeTransport;
	ModeTransportEnum = ModeTransport;
	readOnly: Boolean = false;
	Modules = Modules;
	statique = Statique;
	typeaheadUserEvent: EventEmitter<string> = new EventEmitter<string>();
	listUserTypeahead: Array<EbUser> = new Array<EbUser>();
	selectedUser: EbUser;
	dataInsertion: string = this.statique.controllerStatiqueListe + '/addChat';
	listChat: Array<EbChat> = new Array<EbChat>();
	ebChat: EbChat;
	listExEtablissementCurrency: Array<EbCompagnieCurrency> = new Array<EbCompagnieCurrency>();

	constructor(
		protected chatService: ChatService,
		private pricingService: PricingService,
		private modalService: ModalService,
		private translate: TranslateService,
		protected etablissementService: EtablissementService,
		private completerService: CompleterService,
		private userService: UserService,
		protected cd: ChangeDetectorRef,
		private statiqueService: StatiqueService
	) {


	}

	ngOnInit() {
		this.statiqueService.getListEcCurrency().subscribe(res => {
			this.listCurrency = res;
			res.forEach(it => {
				if (it.ecCurrencyNum == this.ebDemande.xecCurrencyInvoice.ecCurrencyNum)
					this.ebDemande.xecCurrencyInvoice.code = it.code;
			});
		});
		if (this.exEbDemandeTransporteur.xEbCompagnieCurrency == null || this.exEbDemandeTransporteur.xEbCompagnieCurrency.ecCurrency || this.exEbDemandeTransporteur.xEbCompagnieCurrency.ecCurrency.ecCurrencyNum) {

			let searchCriteria: SearchCriteria = new SearchCriteria();
			if (this.userConnected.role == UserRole.PRESTATAIRE && (this.userConnected.service == ServiceType.TRANSPORTEUR || this.userConnected.service == ServiceType.TRANSPORTEUR_BROKER))
				searchCriteria.ebEtablissementNum = this.userConnected.ebEtablissement.ebEtablissementNum;
			else if (this.exEbDemandeTransporteur && this.exEbDemandeTransporteur.xEbEtablissement && this.exEbDemandeTransporteur.xEbEtablissement.ebEtablissementNum)
				searchCriteria.ebEtablissementNum = this.exEbDemandeTransporteur.xEbEtablissement.ebEtablissementNum;
			else
				searchCriteria.ebEtablissementNum = this.ebDemande.xEbEtablissement.ebEtablissementNum;

			searchCriteria.module = this.module;
			searchCriteria.ebCompagnieGuestNum = this.ebDemande.xEbEtablissement.ebCompagnie.ebCompagnieNum;


			this.etablissementService.getListExEtablissementCurrencyforQuotation(searchCriteria).subscribe((data: Array<EbCompagnieCurrency>) => {
				if (data) {
					for (let i: number = 0; i < data.length; i++) {
						if (data[i].ecCurrency.ecCurrencyNum != this.ebDemande.xecCurrencyInvoice.ecCurrencyNum){
							this.listExEtablissementCurrency.push(data[i]);}
					}

					//this.listExEtablissementCurrency = data;
					this.listExEtablissementCurrency.forEach((exEtablissementCurrency: EbCompagnieCurrency, index: number) => {
						this.listExEtablissementCurrency[index] = Statique.cloneObject(exEtablissementCurrency, new EbCompagnieCurrency());
					});
				}
			});
		}


		if (typeof this.hasContributionAccess == "undefined")
			this.hasContributionAccess = true;

		// translation
		this.ConstantsTranslate = {
			CONFIRMATION: '',
			QUOTATION_SENT: '',
		};
		Object.keys(this.ConstantsTranslate).forEach(key => {
			this.translate.get("PRICING_BOOKING." + key).subscribe(res => this.ConstantsTranslate[key] = res)
		});

		this.getCountries();
		this.Modetranspo();
		this.suggetions = this.completerService.remote(Statique.controllerPricing + '/party?company=', 'company', 'company');

		this.listAllCostCategorie = new Array<CostCategorie>();

		this.pricingService.listAllCostCategorie().subscribe(data => {
			this.listAllCostCategorie = data;

			if (!this.exEbDemandeTransporteur.listCostCategorie || this.exEbDemandeTransporteur.listCostCategorie.length == 0) {
				this.exEbDemandeTransporteur.listCostCategorie = new Array<CostCategorie>();
				this.listAllCostCategorie.forEach(it => {
					this.exEbDemandeTransporteur.listCostCategorie.push(JSON.parse(JSON.stringify(it)));
				});
			}

			this.exEbDemandeTransporteur.listCostCategorie.forEach(it => {
				it.isCollapsed = true;
				it.listEbCost.forEach(el => {
					if (el.price != null && el.priceEuro != null && el.xEcCurrencyNum != null) {
						this.listCurrency.forEach(code => {
							if (code.ecCurrencyNum == el.xEcCurrencyNum)
								el.codeCurrency = code.code;
						})
					}
				})
			})
		});
	}

	getCurrency(item: Cost) {
		if (!item || !item.xEcCurrencyNum) return null;
		return this.listCurrency.find(it => it.ecCurrencyNum == item.xEcCurrencyNum);
	}

	Modetranspo() {
		if (this.ebDemande.xEcModeTransport == 1)
			this.modeTranspo = 'Air';
		if (this.ebDemande.xEcModeTransport == 2)
			this.modeTranspo = 'Sea';
		if (this.ebDemande.xEcModeTransport == 3)
			this.modeTranspo = 'Road';
		if (this.ebDemande.xEcModeTransport == 4)
			this.modeTranspo = 'Integrateur';
	}

	compareCountry(country1: EcCountry, country2: EcCountry) {
		if (country2 !== undefined && country2 !== null) {
			return country1.ecCountryNum === country2.ecCountryNum;
		}
	}

	getCountries() {
		this.pricingService.listPays().subscribe(data => {
			this.listCountry = data;
		});
	}

	formatTime() {
		let timeRemaining = "";
	}

	calculCost(cat: CostCategorie, listPostCostCategorie, exEbDemandeTransporteur: ExEbDemandeTransporteur) {
		let total: number = 0;
		let total2: number = 0;
		this.readOnly = true;
		cat.listEbCost.forEach(it => {

			if (it.price != null) {
				if (this.listExEtablissementCurrency.length > 0) {
					if (it.euroExchangeRate != null)
						it.priceEuro = it.price * it.euroExchangeRate;
					else
						it.priceEuro = it.price * 1;
				}
				else {
					it.priceEuro = it.price * 1;
				}

				total2 += it.priceEuro;
				total += it.price;
			} else if (it.price == null)
				it.priceEuro = null;

		})
		cat.price = total;
		cat.priceEuro = total2;
		this.calculPriceTotal(listPostCostCategorie, exEbDemandeTransporteur);
	}

	calculPriceTotal(listPostCostCategorie, exEbDemandeTransporteur) {
		let total: number = 0;
		listPostCostCategorie.forEach(it => {
			if (it.priceEuro != null) {
				total += it.priceEuro;
			}
			exEbDemandeTransporteur.price = total;
		})
	}

	disableField(exEbDemandeTransporteur?) {
		return !(this.isTransporteur() || this.userConnected.role == UserRole.CONTROL_TOWER)
			|| exEbDemandeTransporteur && exEbDemandeTransporteur.status == CarrierStatus.FINAL_CHOICE
			// || this.ebDemande.curentTimeRemainingInMilliSecond <= 0
			|| this.ebDemande.xEcStatut >= DemandeStatus.FINAL_CHOICE
			|| !this.hasContributionAccess;
	}

	isTransporteur() {
		return this.userConnected.service == ServiceType.TRANSPORTEUR
			|| this.userConnected.service == ServiceType.TRANSPORTEUR_BROKER;
	}

	addAutre(cat: CostCategorie) {
		cat.listEbCost.push({ libelle: '', price: null, priceEuro: null, xEcCurrencyNum: null, type: 2 });
	}

	addQuotation(event) {

		let requestProcessing = new RequestProcessing();
		requestProcessing.beforeSendRequest(event);

		this.exEbDemandeTransporteur.xEbDemande = null;

		if (this.userConnected.role == UserRole.PRESTATAIRE) {
			this.exEbDemandeTransporteur.xTransporteur = new EbUser();
			this.exEbDemandeTransporteur.xTransporteur.ebUserNum = this.userConnected.ebUserNum;
			this.exEbDemandeTransporteur.xTransporteur.nom = this.userConnected.nom;

			this.exEbDemandeTransporteur.xEbEtablissement = new EbEtablissement();
			this.exEbDemandeTransporteur.xEbEtablissement.ebEtablissementNum = this.userConnected.ebEtablissement.ebEtablissementNum;
		
			this.exEbDemandeTransporteur.xEbCompagnie = new EbCompagnie();
			this.exEbDemandeTransporteur.xEbCompagnie.ebCompagnieNum = this.userConnected.ebCompagnie.ebCompagnieNum;
		}

		if (this.exEbDemandeTransporteur.status != CarrierStatus.RECOMMENDATION && this.exEbDemandeTransporteur.price)
			this.exEbDemandeTransporteur.status = CarrierStatus.QUOTE_SENT;

		let cat = new Array<CostCategorie>();
		this.exEbDemandeTransporteur.listCostCategorie.forEach(el => {
			if (el.xEcModeTransport == this.ebDemande.xEcModeTransport) {
				cat.push(el);
			}
		})
		this.exEbDemandeTransporteur.listCostCategorie = cat;

		this.exEbDemandeTransporteur.xEbDemande = new EbDemande();
		this.exEbDemandeTransporteur.xEbDemande.ebDemandeNum = this.ebDemande.ebDemandeNum;

		this.pricingService.ajouterQuotation(this.exEbDemandeTransporteur).subscribe(function (res) {
			if (this.ebDemande.flagRecommendation && this.ebDemande.xEcStatut != DemandeStatus.RECOMMENDATION)
				this.ebDemande.xEcStatut = DemandeStatus.WAITING_FOR_RECOMMENDATION;
			else
				this.ebDemande.xEcStatut = DemandeStatus.RECOMMENDATION;

			if (this.userConnected.role == UserRole.CONTROL_TOWER) {

				this.ebChat = new EbChat();
				this.ebChat.userName = this.userConnected.nom + " " + this.userConnected.prenom;
				this.ebChat.xEbUser = this.userConnected.ebUserNum;
				this.ebChat.module = Modules.PRICING;
				this.ebChat.idFiche = this.ebDemande.ebDemandeNum;
				this.ebChat.idChatComponent = this.IDChatComponent.PRICING;
				this.ebChat.text = "Quotation sent by <b> " +
					this.userConnected.nom + " " + this.userConnected.prenom + '</b>' +
					" for <b>" + (this.exEbDemandeTransporteur.xTransporteur ? this.exEbDemandeTransporteur.xTransporteur.nom : '') + '</b>';
				this.chatService.addChat(this.dataInsertion, this.ebChat).subscribe((data) => {
					this.updateChatEmitter.emit(data);
				});
			}

			if (this.isModal) {
				this.feedbackQuotationEmitter.emit(res ? res[0] : null);
			}
			else {
				this.modalService.information(this.ConstantsTranslate.CONFIRMATION, this.ConstantsTranslate.QUOTATION_SENT);
			}

			this.updateCarrierChoiceEmitter.emit();

			requestProcessing.afterGetResponse(event);

		}.bind(this));

	}

	getComment(comment, exEbDemandeTransporteur) {
		exEbDemandeTransporteur.comment = comment;
	}

	showPsl(psl: string) {
		return this.ebDemande.configPsl != null && this.ebDemande.configPsl.indexOf(psl) >= 0;
	}

	handleChangePrice(event: number, item) {
		item.price = event;
	}

	ChangedDevise(item, cat: CostCategorie, listPostCostCategorie, exEbDemandeTransporteur: ExEbDemandeTransporteur) {
		this.listExEtablissementCurrency.forEach(it => {
			if ((item.xEcCurrencyNum == it.ecCurrency.ecCurrencyNum) && (it.xecCurrencyCible.ecCurrencyNum==this.ebDemande.xecCurrencyInvoice.ecCurrencyNum))
				item.euroExchangeRate = it.euroExchangeRate;
			else if ((item.xEcCurrencyNum == it.ecCurrency.ecCurrencyNum) && (it.xecCurrencyCible.ecCurrencyNum!=this.ebDemande.xecCurrencyInvoice.ecCurrencyNum))
				item.euroExchangeRate = 1;
			
		})
		this.calculCost(cat, listPostCostCategorie, exEbDemandeTransporteur);
	}


}





// WEBPACK FOOTER //
// ./src/app/component/pricing-booking/shared-component/cotation/cotation.component.ts